/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * NavbarService layer between component and Content provider service to handle all filtering
 * and data manipulation logic for global navigation data
 */
// tslint:disable
import { Injectable } from '@angular/core';
import { PDL_BRANDS } from '@experience/reb-pdl/constants/pdl.constants';

@Injectable({
  providedIn: 'root',
})
export class CustomeHandlerService {
  constructor() {}

  public myCustomHandler(src: any, dest: any): void {
    if (src.product) {
      dest.product = [src.product];
    } else if (src.productUpdate) {
      dest.product[0].productInfo.availabilityStatus = src.productUpdate.productInfo.availability;
      dest.product[0].productInfo.fullRetailPrice = src.productUpdate.productInfo.price;
      dest.product[0].productInfo.id = src.productUpdate.productInfo.sku;
    } else if (src.user) {
      dest.user = src.user.user;
    }
  }

  public myCustomEventHandler(src: any, dest: any): void {
    if (dest.eventDescription && src.pdlData && src.pdlData.ctaName) {
      dest.eventDescription.ctaName = src.pdlData.ctaName;
    }
    if (dest.product && src.pdlData && src.pdlData.product) {
      dest.product = src.pdlData.product;
    }
    if (src.modal && src.modal.modalName && !src.isModalNameNeeded) {
      dest.eventDescription.modalName = src.modal.modalName;
    }
    if (src.pdlData && src.pdlData.assetType) {
      dest.eventDescription.assetType = src.pdlData.assetType;
    }
  }

  public myCustomGeoLocationHandler(src: any, dest: any): void {
    (navigator as any).permissions.query({ name: 'geolocation' }).then((geoLocation: any) => {
      dest.user.location.geoPermission = geoLocation.state;
    });
    dest.page.pageInfo.referrer = dest.from ? dest.from : '';
    dest.page.pageInfo.url = window.location.href;
    dest.page.pageInfo.icidList = (JSON.stringify(src || {}).match(/(icid=)(\w+)/g) || []).map(
      (rawIcid: string) => rawIcid.split('=')[1]
    );
    dest.page.pageInfo.variant =
      PDL_BRANDS[((document.cookie.match(/brand=(\w+)/) || [])[0] || '=').split('=')[1]];
  }

  public myGenerateEventInfoTimestamp(src: any, dest: any): void {
    dest.eventInfo.timeStamp = new Date().toISOString();
  }

  public selfServiceAction(src: any, dest: any): void {
    if (src.eventData.selfService) {
      dest.selfService = src.eventData.selfService;
    }
    if (src.eventData.attributes) {
      dest.attributes = src.eventData.attributes;
    }
  }

  public myCustomEventHandlerForCart(src: any, dest: any): void {
    if (src.cart) {
      dest.cart.product = src.cart.productInfo;
      dest.cart.promo = src.cart.promo;
      dest.cart.lineCount = src.cart.lineCount;
    } else {
      dest.cart = {};
    }
  }

  public myCustomClickEventHandler(src: any, dest: any): void {
    if (src.eventData) {
      if (src.eventData.eventInfo) {
        dest.eventInfo = src.eventData.eventInfo;
      }
      if (src.eventData.tool) {
        dest.tool = src.eventData.tool;
      }
      if (src.eventData.eventDescription) {
        dest.eventDescription = src.eventData.eventDescription;
      }
      if (src.eventData.searchTerm) {
        dest.searchTerm = src.eventData.searchTerm;
      }
      if (src.eventData.autosearch) {
        dest.autosearch = src.eventData.autosearch;
      }
      if (src.eventData.error) {
        dest.error = src.eventData.error;
      }
      if (src.eventData.attributes) {
        dest.attributes = src.eventData.attributes;
      }
    }
  }

  public myCustomModalEventHandler(src: any, dest: any): void {
    if (src.eventData && src.eventData.tool) {
      dest.tool = src.eventData.tool;
    }
    if (src.eventData && src.eventData.eventDescription) {
      dest.eventDescription = src.eventData.eventDescription;
    }
    if (src.noPlan && src.noPlan.headerText) {
      dest.attributes.modalName = src.noPlan.headerText;
    }
    if (src.serviceWarningModal && src.serviceWarningModal.modalName) {
      dest.attributes.modalName = src.serviceWarningModal.modalName;
    }
  }

  public myCustomRemoveEventHandler(src: any, dest: any): void {
    if (dest.eventDescription) {
      dest.eventDescription.ctaName = src.pdlData.ctaName;
    }
    if (dest.product) {
      dest.product = src.pdlData.product;
    }
    if (src.pdlData && src.pdlData.modalName) {
      dest.eventDescription.modalName = src.pdlData.modalName;
    }
    if (src.pdlData && src.pdlData.assetType) {
      dest.eventDescription.assetType = src.pdlData.assetType;
    }
    if (src.eventData && src.eventData.category) {
      dest.category = src.eventData.category;
    }
  }

  public errorOnPageLoad(src: any, dest: any): void {
    if (src && src.pdlErrorObject && src.pdlErrorObject.length) {
      dest.error = src.pdlErrorObject;
    }
  }
}
